
import { Vue, Component } from 'vue-property-decorator';
import WorkbenchesService from '@/services/workbenches.service';
import lazyInject from '@/di';
import * as echarts from 'echarts';

@Component({})
export default class ConsumptionModal extends Vue {
  @lazyInject(WorkbenchesService)
  workbenchesService!: WorkbenchesService;
  visible = false;
  title = '';
  width = 500;
  height = 500;
  footer = null;
  columns = [
    {
      title: '日期',
      dataIndex: 'date',
      align: 'center',
      width: 120,
    },
    {
      title: '推广通消耗额',
      dataIndex: 'consumption',
      align: 'center',
      width: 120,
    },
  ];
  data: any = [];
  async init(value: any) {
    this.visible = true;
    this.title = '推广通消耗详情';
    this.width = 1000;
    this.height = 800;
    this.footer = null;
    const res = await this.workbenchesService.getAdConsumeDayConstChart(value);
    this.$nextTick(() => {
      this.initEcharts();
    });
    const _year = value.month.split('-');
    function getDaysInMonth(year: number, month: number): number {
      // 注意：month 是从 1 开始的（例如6表示六月）
      // 创建下一个月的第一天，然后减去一天即可得到这个月的最后一天
      return new Date(year, month, 0).getDate();
    }
    const _data: any = getDaysInMonth(_year[0], _year[1]);
    const data = [];
    for (let i = 0; i < _data; i++) {
      const _i = (i + 1) > 9 ? i + 1 : `0${i + 1}`;
      const _text = `${_year[0]}-${_year[1]}-${_i}`;
      data.push({
        date: _text,
        consumption: this.funCost(res.find((item: any) => item.day === _text)?.cost),
      });
    }
    this.data = data;
  }

  funCost(cost: any) {
    if (cost === undefined) {
      return '';
    }
    return cost;
  }

  handleCancel() {
    this.visible = false;
  }
  initEcharts() {
    const data = this.data.map((item: any) => item.date);
    const consumption = this.data.map((item: any) => item.consumption);
    const option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999',
          },
        },
      },
      xAxis: {
        type: 'category',
        data,
        axisLabel: {
          rotate: 30, // 倾斜角度，0-90度
          margin: 10, // 标签与轴线的距离
          interval: 0, // 强制显示所有标签
          // 其他样式设置
          color: '#666',
          fontSize: 10,
        },
      },
      yAxis: {
        type: 'value',
      },
      series: [
        {
          name: '推广通消耗额',
          data: consumption,
          type: 'line',
        },
      ],
    };
    const chart: any = document.getElementById('echart-container');
    const myChart = echarts.init(chart);
    myChart.setOption(option);
  }
}
